import { useState } from 'react'

//MUI
import { FormControl, Grid, TextField, Button, Stack, Box } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';

//Form Validator
import { formValidator } from '../../validators/formVaidator'

import { htmlMsg } from '../../helpers/swal_msg';
import { sendContactEmail, sendQuoteEmail } from '../../actions/form';

import { TARGET_EMAIL } from '../../constants/contants';


const CustomSubmitButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#004A87',
    fontWeight: '900',
    padding: '10px 35px 10px 35px',
    '&:hover': {
        backgroundColor: '#0066b3',
    },
}));

const useStyles = makeStyles({
    root: {
        "& .MuiOutlinedInput-root": {
            background: "#F2F2F2"
        },
        //Border transparent
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: 'transparent',
        },
        //Border hover color
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9aa3a3",
        },
        //Border color focused
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#b2babb",
        },
    }
});

const formInit = {
    name: '',
    email: '',
    msg: '',
}

const SecondForm = ({ type }) => {
    const [data, setData] = useState(formInit)
    const { name, email, msg } = data;

    const classes = useStyles();

    const handleInputChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (formValidator(name, email, msg)) {
            if (type === 'contact')
                await sendContactEmail(data, setData);
            else if (type === 'quote')
                await sendQuoteEmail(data, setData)
            else
                htmlMsg('info', 'Mensaje no enviado',
                `En este momento no se puede enviar su mensaje. Escríbanos al correo
                <a href='mailto:${TARGET_EMAIL}}' style={{ color: '#868686' }}>${TARGET_EMAIL}</a>`);
        }
    }

    return (
        <Grid container spacing={4}>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 }}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        placeholder='Escriba aquí su mensaje...'
                        name='msg'
                        multiline
                        rows={8}
                        value={data.msg}
                        onChange={handleInputChange}
                        slotProps={{
                            input: {
                                className: 'custom_contact_input'
                            }
                        }}
                        inputProps={{
                            maxLength: 400
                        }}
                        helperText={`${data.msg.length} / ${400}`}
                        FormHelperTextProps={{
                            style: {
                                textAlign: 'right',
                                color: data.msg.length >= 360 && data.msg.length < 400 ? '#f5b041' : data.msg.length === 400 ? '#e74c3c' : 'rgba(0, 0, 0, 0.6)',
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 }}>
                <Stack direction='column' spacing={3}>
                    <Box>
                        <FormControl fullWidth>
                            <TextField
                                className={classes.root}
                                placeholder='Nombre'
                                name='name'
                                value={data.name}
                                onChange={handleInputChange}
                                slotProps={{
                                    input: {
                                        className: 'custom_contact_input'
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Box>
                        <FormControl fullWidth>
                            <TextField
                                className={classes.root}
                                placeholder='Correo electrónico'
                                name='email'
                                value={data.email}
                                onChange={handleInputChange}
                                slotProps={{
                                    input: {
                                        className: 'custom_contact_input'
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Box>
                        <CustomSubmitButton variant='contained' onClick={handleSubmit}>Enviar</CustomSubmitButton>
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default SecondForm